import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-stars",
  "use": "oc-stars-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"oc-stars\"><path d=\"M511.786667 85.333333C276.053333 85.333333 85.333333 276.266667 85.333333 512s190.72 426.666667 426.453334 426.666667C747.52 938.666667 938.666667 747.733333 938.666667 512S747.52 85.333333 511.786667 85.333333z m180.693333 682.666667L512 659.2 331.52 768l47.786667-205.226667-159.146667-138.026666 209.92-17.92L512 213.333333l81.92 193.493334 209.92 17.92-159.146667 138.026666L692.48 768z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol